import React from 'react'
import OverViewTableComponent from './OverViewTableComponent'
import { ReactComponent as Arrow } from '../../../../assets/svg/ProjectOverview/Up-Arrow-Icon.svg';

const EventsTable = ({columns,datasource,name,count,width,height,onGoTo}) => {

   

  return (
    <div className='EventsTableComponent' style={{width:width,height:height}}>
        <div className='tabelTitle'>
         <div>
         <span> {name}</span>
           <span className='counts'>{count}</span>
         </div>
         <span name="hardDrive" onClick={onGoTo}
          style={{cursor:"pointer",border:"0.2px solid rgba(239, 239, 239, 0.60)",display:"flex",justifyContent:"center",alignItems:"center",padding:"2%"}}>
          <Arrow/>
          </span>
           
        </div>
        <OverViewTableComponent dataSource={datasource} columns={columns}/>
    </div>
  )
}

export default EventsTable